import { SimpleForm, TextInput, useRecordContext, required, useNotify, Create } from 'react-admin';
import { EditToolbar } from '../../common/EditToolbar';
import { useNavigate } from 'react-router';
import { goApi } from '../../services';

const LiveCannelCreate = () => {
    const navigate = useNavigate();
    const notify = useNotify();

    const postSave = async (data: any) => {
        try {
            const payload = {
                ...data,
            };
            await goApi.post('/live-videos/channel/create', payload);
            notify('Live channel created successfully', { type: 'success' });
            navigate('/live_channels');
        } catch (err) {
            notify('Failed to create live channel', {
                type: 'error',
            });
        }
    };

    return (
        <Create title={<LiveCannelTitle />}>
            <SimpleForm onSubmit={postSave} toolbar={<EditToolbar />}>
                <TextInput source="name" validate={[required()]} fullWidth />
            </SimpleForm>
        </Create>
    );
};

const LiveCannelTitle = () => {
    const record = useRecordContext();

    return record ? <span>{record.name}&quot;</span> : null;
};

export default LiveCannelCreate;
